<template>
    <div id="app">
        <ScaleBox
            :width="1920"
            :height="1080"
            bgc="transparent"
            :delay="100"
        >
            <template>
                <div id="shows">
                    <header @click="goto_home" >
                        <!--                         <span style=" font-size:14px; position: absolute; left: 30px; top:-20px; ">晴,4~21度</span>-->
                        <span style="cursor: pointer">羲和太阳能路灯管理平台</span>
                        <span style=" font-size:14px; position: absolute; right: 30px; top:-20px; ">{{
                                localtime
                            }}</span>
                    </header>
                    <div id="content">
                        <div class="content_left">
                            <div class="top_title"><img src="../assets/img_013/icon03.png"/> 项目信息</div>
                            <div class="dtuplc" style="color: #00f6ff;padding: 5px">
                                <div style="padding:70px 20px 5px 20px">
                                    <p>名称 : {{ current_project.projectName }}
                                        <el-popover
                                            placement="top-start"
                                            trigger="click"
                                            v-model="visible"
                                        >
                                            <el-select v-model="select_value" placeholder="请选择"
                                                       @change="change_currentProject()">
                                                <el-option
                                                    v-for="(item,index) in project"
                                                    :key="index"
                                                    :label=(item.projectName)
                                                    :value="index"
                                                >
                                                </el-option>
                                            </el-select>
                                            <el-link type="primary" slot="reference">切换</el-link>
                                        </el-popover>
                                    </p>

                                </div>
                                <div style="padding:5px 20px"><p>地区 : {{ current_project.address }}</p></div>
                                <div style="padding:5px 20px"><p>天气 : {{
                                        first_day_weather.text_day
                                    }}转{{ first_day_weather.text_night }},{{
                                        first_day_weather.low
                                    }}~{{ first_day_weather.high }}度</p></div>

                                <!--                                <el-row :gutter="20">
                                                                    <el-col :span="24"><div class="grid-content bg-purple">项目名称:</div></el-col>

                                                                </el-row>
                                                                <el-row :gutter="20">
                                                                    <el-col :span="24"><div class="grid-content bg-purple">地区:</div></el-col>

                                                                </el-row>-->

                                <!--                                                    <el-descriptions :column="2"  style="background: white !important;">
                                                                                        <el-descriptions-item label="名称"  :span="2">kooriookami</el-descriptions-item>

                                                                                        <el-descriptions-item label="地区" :span="2">江苏省苏州市吴中区</el-descriptions-item>
                                                                                    </el-descriptions>-->
                                <!--                    <div class="dtu">
                                                        <div id="container" style="height: 100%;"></div>
                                                    </div>
                                                    <div class="plc">
                                                        <div id="container1" style="height: 100%"></div>
                                                    </div>-->
                            </div>
                            <!--
                                DTU和PLC完
                            -->

                            <div class="online" v-loading="getDevice_loading">
                                <div class="title"><img src="../assets/img_013/icon01.png"/> 项目设备概况</div>
                                <div class="online_con" id="container2">
                                    <div class="info-main">
                                        <ul>
                                            <li @click="setView"><img src="../assets/icon/设备管理.png" alt=""><span>设备总数</span>
                                                <p>{{ device_num }}台</p></li>
                                            <li><img src="../assets/icon/STS开关.png" alt=""><span>在线数</span>
                                                <p> {{ light_online_num }}台</p></li>
                                            <li><img src="../assets/icon/灯.png" alt=""><span>亮灯数</span>
                                                <p>{{ light_on_num }}台</p></li>
                                            <li><img src="../assets/icon/报警.png" alt=""><span>报警记录</span>
                                                <p>0条</p></li>
                                        </ul>
                                    </div>
                                    <!--                        <el-row :gutter="20">
                                                                <el-col :span="12">
                                                                    <div class="grid-content bg-purple">

                                                                        <img src="../assets/icon/设备管理.png" alt="">
                                                                        <span>设备总数</span>
                                                                        <p>1台</p>
                                                                    </div>
                                                                </el-col>
                                                                <el-col :span="12">
                                                                    <div class="grid-content bg-purple"></div>
                                                                </el-col>
                                                            </el-row>
                                                            <el-row :gutter="20">
                                                                <el-col :span="12">
                                                                    <div class="grid-content bg-purple"></div>
                                                                </el-col>
                                                                <el-col :span="12">
                                                                    <div class="grid-content bg-purple"></div>
                                                                </el-col>
                                                            </el-row>-->

                                </div>
                            </div>
                            <div class="industry">
                                <div class="title"><img src="../assets/img_013/icon02.png"/></div>
                                <div class="industry_con" id="container3">
                                    <div id="echarts_6" class="charts" style="width: 100%;height: 300px">


                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="content_center">
                            <div class="center_top">
                                <div class="title"><img src="../assets/img_013/icon03.png"/> 设备地理位置分布</div>
                                <div class="center_top_con" id="distribution_map">

                                    <div id="map" style="width: 94%;height: 98%;margin: auto;border-radius: 20px" v-loading="getinfo_loading">
                                        <div class="input-card" v-if="show_control">

                                            <el-descriptions  :column="2" border

                                                             :contentStyle="{'box-shadow': '0 2px 6px 0 rgba(114, 124, 245, .5)','background-color':'black','border':'0px','color':'white'}"
                                                             :labelStyle="{'box-shadow': '0 2px 6px 0 rgba(114, 124, 245, .5)','background-color':'black','border':'0px','color':'white'}">
                                                <el-descriptions-item label="设备ID">{{device_info.device.id}}</el-descriptions-item>
                                                <el-descriptions-item label="状态">{{ control ? '在线' : '离线' }}</el-descriptions-item>
                                                <el-descriptions-item label="开关"  span="2" v-if="control">
                                                    <el-switch
                                                        @change="switch_change($event,device_info)"
                                                        v-model="light_switch"
                                                        active-color="#13ce66"
                                                        inactive-color="#ff4949">
                                                    </el-switch>
                                                </el-descriptions-item>
                                                <el-descriptions-item label="通讯时间"  span="2">{{device_info.time}}</el-descriptions-item>
                                                <el-descriptions-item label="信号">{{device_info.param == 'none' ? '未知' : '-'+device_info.param.riss + 'dbm' }}</el-descriptions-item>
                                                <el-descriptions-item label="温度">{{device_info.param == 'none' ? '未知' : (device_info.param.cpuTemp) + '度' }}</el-descriptions-item>
                                                <el-descriptions-item label="电压">{{device_info.param == 'none' ? '未知' : (device_info.param.vol).toFixed(1) + 'V' }}</el-descriptions-item>
                                                <el-descriptions-item label="电流">{{device_info.param == 'none' ? '未知' : (device_info.param.current).toFixed(1) + 'A' }}</el-descriptions-item>
                                                <el-descriptions-item label="功率">{{device_info.param == 'none' ? '未知' : (parseFloat(device_info.param.vol)*parseFloat(device_info.param.current)).toFixed(2) + 'W' }}</el-descriptions-item>

                                                <el-descriptions-item label="总电量">{{device_info.param == 'none' ? '未知' : (device_info.param.kwh).toFixed(1) + 'kwh' }} </el-descriptions-item>
                                                <el-descriptions-item :label="'亮度:'+brightness" span="2"  v-if="control">
                                                    <el-slider v-model="brightness"  @change="change_brightness($event,device_info)"></el-slider>
                                                </el-descriptions-item>
<!--                                                <el-descriptions-item label="调节" span="2"></el-descriptions-item>-->

                                            </el-descriptions>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="center_bot">
                                <el-table
                                    highlight-current-row
                                    @row-click="clickRow"
                                    :data="tableData"
                                    height="280px"
                                    show-overflow-tooltip="true"

                                    ref="multipleTable"
                                    :header-cell-style="{'text-align':'center','color':'#00f6ff','font-size':'14px'}"
                                    :row-style="{'text-align':'center','color':'#00f6ff'}"

                                    style="width: 100%">
                                    <el-table-column
                                        align="center"
                                        prop="id"
                                        label="设备ID"
                                       >
                                    </el-table-column>
                                    <el-table-column
                                        align="center"
                                        prop="nickName"
                                        label="备注名"
                                        >
                                    </el-table-column>
                                    <el-table-column
                                        align="center"
                                        show-overflow-tooltip
                                        prop="light_state"
                                        label="灯况"
                                       >
                                    </el-table-column>
                                    <el-table-column
                                        align="center"
                                        show-overflow-tooltip
                                        prop="state"
                                        label="状态"
                                       >
                                    </el-table-column>

<!--                                    <el-table-column
                                        align="center"
                                        show-overflow-tooltip
                                        prop="brightness"
                                        label="亮度"
                                        width="150">
                                    </el-table-column>
                                    <el-table-column
                                        align="center"
                                        show-overflow-tooltip
                                        prop="vol"
                                        label="电压"
                                        width="150">
                                    </el-table-column>
                                    <el-table-column
                                        align="left"
                                        show-overflow-tooltip
                                        prop="current"
                                        label="电流"
                                        width="150">
                                    </el-table-column>-->
<!--                                    <el-table-column
                                        align="center"
                                        prop="time"
                                        label="通讯时间">
                                    </el-table-column>-->
                                </el-table>
                                <!--                                <div class="title" style="width: 100% !important;"><img src="../assets/img_013/icon03.png"/> 项目设备列表</div>-->
                                <!--                                <table class="panel-table" bordercolor="#0d48e0" border="1">
                                                                    <tbody>
                                                                    <tr class="aaa" align="center">
                                                                        <td style="color: #00fcff; font-size: 18px; padding: 5px 0;">序号</td>
                                                                        <td style="color: #00fcff; font-size: 18px; padding: 5px 0;">设备ID</td>
                                                                        <td style="color: #00fcff; font-size: 18px; padding: 5px 0;">状态</td>
                                                                        <td style="color: #00fcff; font-size: 18px; padding: 5px 0;">最后通讯</td>
                                                                        <td style="color: #00fcff; font-size: 18px; padding: 5px 0;">电压</td>
                                                                        <td style="color: #00fcff; font-size: 18px; padding: 5px 0;">操作</td>
                                                                    </tr>
                                                                    <tr v-for="item in 1" class="aaa" style="font-size: 16px;" align="center">
                                                                        <td>1</td>
       46                                                                 <td>123333</td>
                                                                        <td>在线</td>
                                                                        <td>22222</td>
                                                                        <td>3333333</td>
                                                                        <td width="250">
                                                                            <button class="b1 click_pop">报警记录</button>
                                                                            <button class="b2 click_pop2">历史数据</button>
                                                                            <button class="b3 click_pop3">组态应用</button>
                                                                        </td>
                                                                    </tr>
                                                                    </tbody>
                                                                </table>-->
                            </div>
                        </div>
                        <div class="content_right">
                            <div class="report">
                                <div id="echarts_4" class="charts" style="width: 100%;height: 150px"></div>


                            </div>
                            <div class="news_report">
                                <div class="title"><img src="../assets/img_013/icon05.png"/> 报警记录</div>

                                <div class="news_list">
                                    <el-table
                                        :data="tableData2"
                                        height="calc(38vh - 80px)"
                                        show-overflow-tooltip="true"
                                        :header-cell-style="{'text-align':'center','color':'white'}"
                                        :row-style="{'text-align':'center','color':'white'}"
                                        style="width: 100%">


                                        <el-table-column
                                            align="center"
                                            prop="time"

                                            label="详细内容">
                                        </el-table-column>
                                    </el-table>
                                    <!--                                    <ul>
                                                                            <li class="li02">
                                                                                出现掉电异常，请注意
                                                                            </li>
                                                                            <li class="li02">
                                                                                出现掉电异常，请注意
                                                                            </li>
                                                                            <li class="li02">
                                                                                出现掉电异常，请注意
                                                                            </li>
                                                                            <li class="li02">
                                                                                出现掉电异常，请注意
                                                                            </li>

                                                                        </ul>-->
                                </div>
                            </div>
                            <div class="data_box">
                                <div class="title"><img src="../assets/img_013/icon06.png"/>近期功耗</div>
                                <div class="data_con" id="container4">

                                </div>
                            </div>
                        </div>
                    </div>


                </div>
            </template>
        </ScaleBox>
    </div>
</template>


<script>

import * as echarts from 'echarts'
import AMapLoader from "@amap/amap-jsapi-loader";
import ScaleBox from 'vue2-scale-box'
import mqtt from 'mqtt'
import MarkIcon_lighton from '@/assets/icon/lamp_lighton.png'
import MarkIcon_lightoff from '@/assets/icon/lamp_ligthoff.png'
import MarkIcon_offline from '@/assets/icon/lamp_offline.png'
import MarkIcon_switch_on from "@/assets/icon/switch_on.png";
import MarkIcon_multi_on from "@/assets/icon/开灯.png";
import MarkIcon_switch_off from "@/assets/icon/switch_off.png";
import MarkIcon_multi_off from "@/assets/icon/关灯.png";
import MarkIcon_switch_offline from "@/assets/icon/switch_offline.png";
import MarkIcon_multi_offline from "@/assets/icon/灯离线.png";


// 配置mqtt
var client = null
let timer
const options = {
    connectTimeout: 15000,
 //   clientId: process.env.VUE_APP_CLIENT_ID,      //提取到配置文件
    username: process.env.VUE_APP_MQTT_UESRNAME,  //提取到配置文件
    password: process.env.VUE_APP_MQTT_PASSWORD,  //提取到配置文件
    clean: true
}

export default {
    components: {
        ScaleBox
    },
    data() {
        return {
            clientId:'1222',
            localtime: '',
            infoWindow: '',
            tableData: [],
            tableData2: [],
            user: localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")) : {},
            weather: '',
            first_day_weather: '',
            project: '',
            current_project: '',
            current_device: '',
            select_value: 0,
            getDevice_loading: true,

            device_num: 0, //设备总睡
            light_num: 0,//单灯数
            switch_num: 0,//开关数

            online_num: 0, //在线设备数
            light_online_num: 0,//在线单灯数
            switch_online_num: 0,//在线开关数


            light_on_num: 0, //开灯数
            switch_on_num: 0,//开闸数

            show_control:false, //点击设备后显示在地图上的信息控制面板
            control:false,//设备在线才可进行控制
            getinfo_loading:false,
            brightness:50,
            light_switch:false,//灯的开关
            device_info: {
                device: '',
                param: ''

            },
        }
    },
    created() {
        this.init();

    },

    mounted() {  // 页面元素渲染之后再触发
        options.clientId = "pc_web"

        this.initAMap();
        this.tick()  //右上角时钟
        this.mqttMsg()

        //this.chars6()
        this.chars4()
    },

    destroyed() {
        if (client) {
            client.end() //离开页面的时候  关闭mqtt连接
            client = null
        }
    },
    computed: {
        // mqtt 连接地址
        mqttUrl: () => process.env.VUE_APP_MQTT_URL,  //提取到配置文件
        topic: () => process.env.VUE_APP_TOPIC,       //提取到配置文件
        topic1: () => process.env.VUE_APP_TOPIC1,       //提取到配置文件
        topic2: () => process.env.VUE_APP_TOPIC2,       //提取到配置文件
    },

    methods: {
        init() {

        },

        async load() {
            this.tableData = []
            this.page_loading = true
            this.request.get("/project/findByUser/" + this.user.id, {}).then(res => {
                this.project = res.data
                this.current_project = res.data[0]
                this.getDevices(res.data[0].id)

             /*   if(localStorage.getItem("ebt_current_select_project")==undefined){
                   console.log("判断undefined")
                    this.current_project = res.data[0]
                    this.getDevices(res.data[0].id)
                }else{
                    console.log("ebt_current_select_project存在")
                    let curr = localStorage.getItem("ebt_current_select_project")
                    if(curr >= this.project.length){//如果当前的index大于集合的长度
                        console.log("当前的index大于集合的长度")
                        this.current_project = res.data[0]
                        this.getDevices(res.data[0].id)
                    }else{
                        console.log("当前的index正常")
                        this.current_project = res.data[curr]
                        this.getDevices(res.data[curr].id)
                    }
                }
*/


                console.log(this.current_project)
                /* this.projectName = res.data[0].projectName
                 this.projectAddress = res.data[0].address*/
                this.weather = JSON.parse((res.data[0].weather + ""))
                //console.log(this.weather.results[0].daily)
                this.first_day_weather = this.weather.results[0].daily[0]
                //console.log(this.first_day_weather)
               // this.getDevices(res.data[0].id)

                /* this.get_SunTime()
                 this.getWarn()
                 this.getPowerWeek()
                 this.get_SunTime()
                 this.getAllPower()*/
                /*   this.page_loading = false*/
            })

        },
        getDevices(pid) {
            this.device_num = 0
            this.light_num = 0
            this.switch_num = 0

            this.online_num = 0,
            this.light_online_num = 0,
            this.switch_online_num = 0,

            this.light_on_num = 0,
            this.switch_on_num = 0,

            this.getDevice_loading = true
            this.request.get("/devices/findByPid", {
                params: {
                    pid: pid,
                    tid: ''
                }
            }).then(res => {
                //清除地图
                if (this.map != null) {
                    this.map.clearMap()
                }
                console.log(res.data)
                this.getDevice_loading = false
                this.device_num = res.data.device.length
                this.online_num = res.data.online
                this.lighton_num = res.data.lightOn

                 let dData = res.data.device
                 for (let i = 0; i < dData.length; i++) {
                     if (dData[i].type == 'light' || dData[i].type == 'multi'|| dData[i].type == 'mqtt_light') {
                         this.light_num = this.light_num + 1
                         if (dData[i].online) {
                             this.light_online_num = this.light_online_num + 1
                         }
                         if (dData[i].light_on) {
                             this.light_on_num = this.light_on_num + 1
                         }
                        console.log(dData[i])
                        this.add_maker(dData[i])

                         let table_data = {}
                         table_data.index = i + 1
                         table_data.id = dData[i].id
                         table_data.nickName = dData[i].nickName
                         table_data.state =dData[i].online ? "在线" : "离线"
                         table_data.light_state =dData[i].light_on ?"亮灯" : "关灯"
                         table_data.lat =dData[i].lat
                         table_data.lng =dData[i].lng
                       /*  table_data.online = device[v].online ? "在线" : "离线"
                         table_data.type = device[v].type
                         table_data.light_on = device[v].light_on ? "开启" : "关闭"
                         table_data.latlng = device[v].lat + "," + device[v].lng
                         table_data.planstate = device[v].planState*/
                         this.tableData.push(table_data)

                     } else {
                         this.switch_num = this.switch_num + 1
                         if (dData[i].online) {
                             this.switch_online_num = this.switch_online_num + 1
                         }
                         if (dData[i].light_on) {
                             this.switch_on_num = this.switch_on_num + 1
                         }
                     }
                 }


                let option = {
                    tooltip: {
                        trigger: 'item'
                    },

                    series: [
                        {
                            name: '设备概况',
                            type: 'pie',
                            radius: ['40%', '70%'],
                            avoidLabelOverlap: false,

                            itemStyle: {
                                borderRadius: 10,
                                borderColor: '#fff',
                                borderWidth: 2,
                                normal: {
                                    color: function (colors) {
                                        var colorList = [
                                            'rgb(162,244,66)',
                                            'rgb(149,149,150)',
                                            '#e3131a',
                                            '#ef6567',
                                            '#9c1657',
                                            '#75bedc'
                                        ];
                                        return colorList[colors.dataIndex];
                                    }
                                },
                            },
                            emphasis: {
                                itemStyle: {
                                    shadowBlur: 10,
                                    shadowOffsetX: 0,
                                    shadowColor: 'rgb(86,239,247)'

                                }
                            },
                            label: {            //饼图图形上的文本标签
                                normal: {
                                    show: true,
                                    position: 'outer', //标签的位置
                                    textStyle: {
                                        fontWeight: 300,
                                        fontSize: 14,    //文字的字体大小
                                        color: "#fff"
                                    },
                                    formatter: '{b}:{c}'
                                }
                            },
                            data: [
                                {value: 0, name: '在线数'},
                                {value: 0, name: '离线数'},

                            ]
                        }
                    ]
                };
                option.series[0].data[0].value = this.light_online_num
                option.series[0].data[1].value = this.light_num - this.light_online_num
                var chartDom = document.getElementById('echarts_6');
                var myChart = echarts.init(chartDom);
                // 数据准备完毕之后再set
                myChart.setOption(option);

                this.setView()
            })

        },
        add_maker(data){
            //console.log(data)
            //console.log("创建maker"+data)
            let mark_img = ''
            if (data.online == true) {
                if (data.light_on == true) {
                        mark_img = MarkIcon_lighton
                } else {
                        mark_img = MarkIcon_lightoff
                }
            } else {
                mark_img = MarkIcon_offline

            }

            // 创建一个 Icon
            var startIcon = new AMap.Icon({
                // 图标尺寸
                size: new AMap.Size(30, 30),
                // 图标的取图地址
                image: mark_img,
                // 图标所用图片大小
                imageSize: new AMap.Size(30, 30),

            });
            var marker = new AMap.Marker({
                map: this.map,
                icon: startIcon,
                offset: new AMap.Pixel(-15, -30),
                position: [data.lng, data.lat]
            });

            marker.on("click", () => {
                //等同于点了表格里面的数据
                console.log("点击了maker"+data.id)
                this.current_device = data
                this.request_online(data)
                //this.$refs.multipleTable.setCurrentRow(this.$refs.multipleTable.data[0]);
                //let point = {latlng: device[v].lat + "," + device[v].lng, deviceId: device[v].id}
                //this.location(point, v)
            })
        },
        change_currentProject() {
            this.tableData = []
            console.log(this.select_value)
            localStorage.setItem("ebt_current_select_project", this.select_value)  // 存储用户信息到浏览器

            this.current_project = this.project[this.select_value]
            this.visible = false

            this.weather = JSON.parse((this.project[this.select_value].weather + ""))
            this.first_day_weather = this.weather.results[0].daily[0]
            this.getDevices(this.project[this.select_value].id)
            /*
              this.getWarn()
              this.getPowerWeek()
              this.get_SunTime()
              this.getAllPower()*/

        },
        setView() {
            this.reset()
            this.map.setFitView();
           /* setTimeout(() => {
                this.map.setFitView();
            }, 500);*/

        },

        //表格行点击时间
        clickRow(row, column, event){
          /*  console.log(row)
            console.log(column)
            console.log(event)*/
            this.current_device = row
            this.request_online(row)
        },

        //发一次mqtt请求设备信息，判断是否在线
        request_online(row){
            let that = this
            //先请求一次，判断是否在线
            this.commandIssue('ebt/pwmlight/' + row.id + '/getInfo', '1')
            this.getinfo_loading = true
            /* uni.showLoading({
                 title: "状态获取中",
                 mask: true
             })*/
            timer = setTimeout(function() {

                that.$message({
                    message: '设备不在线',
                    center: true,
                    type:'error',
                    offset:220
                });
              //  that.$message.error('设备不在线');
                //uni.hideLoading()
                /* uni.showToast({
                     title:"设备不在线",
                     icon:'error'
                 })*/
                that.getinfo_loading = false
                that.control = false
                that.show_control = false
            }, 1500);
        },
        getDevice_detail(){
            console.log(this.current_device)
            if(this.current_device==''){
                return false
            }
            this.map.setCenter([this.current_device.lng, this.current_device.lat])
            this.map.setZoom(18)
            this.show_control = true
            this.request.get("/devices/" + this.current_device.id, {}).then(res => {
                console.log(res.data)
                this.device_info = res.data
                if (JSON.stringify(res.data.param) == '{}') {
                    this.device_info.param = "none"
                    this.device_info.time = '未上线'
                } else {
                    this.device_info.param = res.data.param
                    this.device_info.time = this.getdate(res.data.param.time * 1000)
                }
            })
        },
        addMarker() {
            var markers = [{
                icon: '//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-1.png',
                position: [116.205467, 39.907761]
            }, {
                icon: '//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-2.png',
                position: [116.368904, 39.913423]
            }, {
                icon: '//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-3.png',
                position: [116.305467, 39.807761]
            }];

            let that = this
            // 添加一些分布不均的点到地图上,地图上添加三个点标记，作为参照
            markers.forEach(function (marker) {
                new AMap.Marker({
                    map: that.map,
                    icon: marker.icon,
                    position: [marker.position[0], marker.position[1]],
                    offset: new AMap.Pixel(-13, -30)
                });
            });


            // 创建一个 Icon
            var startIcon = new AMap.Icon({
                // 图标尺寸
                size: new AMap.Size(25, 34),
                // 图标的取图地址
                image: '//a.amap.com/jsapi_demos/static/demo-center/icons/dir-marker.png',
                // 图标所用图片大小
                imageSize: new AMap.Size(135, 40),
                // 图标取图偏移量
                imageOffset: new AMap.Pixel(-9, -3)
            });


            var marker = new AMap.Marker({
                map: this.map,
                icon: startIcon,
                offset: new AMap.Pixel(-13, -30),
                position: [118.018124, 24.464386]
            });

            /*this.infoWindow = new AMap.InfoWindow({
                isCustom: true,  //使用自定义窗体
                content: this.set_info(),
                offset: new AMap.Pixel(16, -45)
            });
*/


            //构建信息窗体中显示的内容
            var info = [];

            info.push("<div style=\"padding:3px; border-radius: 25px\"><h4 style=\"background: #3F5EFB\">报警提醒</h4>");
            info.push("<p class='input-item'>有人进入</p>");
            info.push("<p class='input-item'>地址 :北京市朝阳区望京阜荣街</p></div></div>");

            this.infoWindow = new AMap.InfoWindow({
                content: info.join(""),  //使用默认信息窗体框样式，显示信息内容
                offset: new AMap.Pixel(0, -35)
            });

            this.infoWindow.open(this.map, marker.getPosition());


            // infowidnow 的 innerHTML
            /*   var infoWindowContent =
                   '<div className="custom-infowindow input-card">' +
                   '<label style="color:grey">故宫博物院</label>' +
                   '<div class="input-item">' +
                   '<div class="input-item-prepend">' +
                   '<span class="input-item-text" >经纬度</span>' +
                   '</div>' +
                   '<input id="lnglat" type="text" />' +
                   '</div>' +
                   // 为 infowindow 添加自定义事件
                   '<input id="lnglat2container" type="button" class="btn" value="获取该位置经纬度" onclick="getLngLat()"/>' +
                   '</div>';

               // 创建一个自定义内容的 infowindow 实例
               this.infoWindow   = new AMap.InfoWindow({
                   offset: new AMap.Pixel(0, -35),
                   content: infoWindowContent
               });*/


            //实例化信息窗体
            /* var title = '方恒假日酒店<span style="font-size:11px;color:#F00;">价格:318</span>',
                 content = [];
             content.push("<img src='http://tpc.googlesyndication.com/simgad/5843493769827749134'>地址：北京市朝阳区阜通东大街6号院3号楼东北8.3公里");
             content.push("电话：010-64733333");
             content.push("<a href='https://ditu.amap.com/detail/B000A8URXB?citycode=110105'>详细信息</a>");
             this.infoWindow   = new AMap.InfoWindow({
                 isCustom: true,  //使用自定义窗体
                 content: that.createInfoWindow(title, content.join("<br/>")),
                 //offset: new AMap.Pixel(16, -45)
             });

             this.infoWindow.open(this.map, marker.getPosition());
 */
        },
        set_info() {


        },

        createInfoWindow(title, content) {
            var info = document.createElement("div");
            info.className = "custom-info input-card content-window-card";

            //可以通过下面的方式修改自定义窗体的宽高
            //info.style.width = "400px";
            // 定义顶部标题
            var top = document.createElement("div");
            var titleD = document.createElement("div");
            var closeX = document.createElement("img");
            top.className = "info-top";
            titleD.innerHTML = title;
            closeX.src = "https://webapi.amap.com/images/close2.gif";
            //closeX.onclick = closeInfoWindow;

            top.appendChild(titleD);
            //  top.appendChild(closeX);
            info.appendChild(top);

            // 定义中部内容
            var middle = document.createElement("div");
            middle.className = "info-middle";
            middle.style.backgroundColor = 'white';
            middle.innerHTML = content;
            info.appendChild(middle);

            // 定义底部内容
            var bottom = document.createElement("div");
            bottom.className = "info-bottom";
            bottom.style.position = 'relative';
            bottom.style.top = '0px';
            bottom.style.margin = '0 auto';
            var sharp = document.createElement("img");
            sharp.src = "https://webapi.amap.com/images/sharp.png";
            bottom.appendChild(sharp);
            info.appendChild(bottom);
            return info;
        },

        initAMap() {
            AMapLoader.load({
                key: '9b16e0ac0b56127f48f850a970ad12ff',
                version: "2.0",
                plugins: ['AMap.ToolBar', 'AMap.Driving', 'AMap.MarkerCluster', 'AMap.MapType', 'AMap.Geolocation'],
                AMapUI: {
                    version: "1.1",
                    plugins: [],
                },
                Loca: {
                    version: "2.0"
                },
            }).then((AMap) => {
                this.map = new AMap.Map("map", {
                    //viewMode: "3D",
                    zoom: this.zoom,
                    zooms: [4, 20],
                    center: this.center,
                });
                var styleName = "amap://styles/darkblue";
                this.map.setMapStyle(styleName);
                this.map.on("click", () => { //地图点击事件
                   this.reset()
                    //this.rest_marker()//重置marker状态
                })

                //地图加载完成后，再请求数据
                this.load()
                //this.addMarker()
            }).catch(e => {
                console.log(e);
            })

        },
        reset(){
            this.show_control = false
            this.$refs.multipleTable.setCurrentRow();
            this.current_device=''
        },
        tick() {
            let today;
            today = new Date();
            this.localtime = this.showLocale(today)
            //document.getElementById("localtime").innerHTML = showLocale(today);
            window.setTimeout(this.tick, 1000);
        },
        goto_home() {
            console.log(1234)
            // this.$router.push({path: '/home'});
            window.location.replace('/home')
        },

        //切换开关
        switch_change(value, device_info) {
            console.log("---切换开关----")
            console.log(value)

            console.log(this.light_switch)

            //this.light_switch =value
            let order = ''
            let msg = ''
            if (value) {
                order = 'ebt/pwmlight/' + device_info.device.id + '/control'
                msg = '1'
            } else {
                order = 'ebt/pwmlight/' + device_info.device.id + '/control'
                msg = '0'
            }
            console.log(order)
            console.log(msg)
            this.commandIssue(order, msg)

        },
        change_brightness(value, device_info){
            console.log("---改变亮度----")
            console.log("---"+value+"----")

            /* ebt/pwmlight/2022740000/dimming    90 */
            this.commandIssue('ebt/pwmlight/' + device_info.device.id + '/dimming', value)

            /* 	setTimeout(function() {
                    uni.stopPullDownRefresh();
                }, 500); */
        },

        mqttMsg() {
            let that = this
            console.log(this.mqttUrl)
            console.log(options)
            if (!client) {
                client = mqtt.connect(this.mqttUrl, options)
            }
            // mqtt连接
            client.on('connect', (e) => {
                console.log(e, "MQTT连接成功！！！")
                client.subscribe( this.topic, {
                    qos: 0
                }, err => {
                    console.log(err || '订阅成功');

                    setTimeout(function() {
                        //that.commandIssue('ebt/pwmlight/' +20227400006 + '/getInfo',1)
                        //client.publish('ebt/pwmlight/' +20227400006 + '/getInfo', 0,1);
                    }, 500);

                    //this.show(err || '订阅成功');
                });


                /*client.subscribe([this.topic, this.topic1, this.topic2], {qos: 0}, (error) => {  // qos 为通道
                    if (!error) {
                        console.log('消息订阅成功')
                    } else {
                        console.log('消息订阅失败')
                    }
                })*/
            })
            // 接收消息处理
            client.on('message', (topic, message) => {
                console.log('收到来自', topic, '的消息---->>', message.toString())
                this.mqMsg = message.toString()

                clearTimeout(timer)//清除定时器
                //uni.hideLoading()

               // this.receiveMessage = message

                this.getDevice_detail()

                let top = topic.split("/")
                let last_word = top[top.length-1]

                //info       20227400001,1673593139,info,1,100,  17:00-06:00,100,0;17:00-06:00,100,1
                //info       20227400001,1675133135,dimming,1  调光后的返回
                //electric   20227400001,1673592962,231.0303030303,0.29499072356215,0.97803064800333,4.72635427381,19,1, 39.07   electric
                if(last_word=='info'){//主动请求的返回
                    console.log("info的返回")
                    this.control = true //表示设备在线，可控制
                    this.getinfo_loading = false //去掉遮蔽
                    let message_body = message.toString().split(",")
                    console.log(message_body)
                    if(message_body[2]=="info"){
                        if(message_body[3]=="1"){
                            this.light_switch = true
                        }else{
                            this.light_switch = false
                        }
                        console.log(message_body[4])
                        this.brightness = parseInt(message_body[4]) //灯的亮度
                    }else if(message_body[2]=="dimming"){
                        this.brightness =parseInt(message_body[3]) //灯的亮度
                    }else if(message_body[2]=="switch"){
                        if(message_body[3]=="1"){
                            this.light_switch = true
                        }else{
                            this.light_switch = false
                        }
                        this.brightness = parseInt(message_body[4])//灯的亮度
                    }
                }else if(last_word=='electric'){//电量变化
                    console.log("电量变化")
                    let message_body = message.toString().split(",")
                    console.log(message_body)
                }
            })
            // 断开发起重连
            client.on('reconnect', (error) => {
                console.log('正在重连:', error)
            })
            // 链接异常处理
            client.on('error', (error) => {
                console.log('连接失败:', error)
            })
        },
        //下发指令
        commandIssue(order,msg) {
            console.log("发送命令"+order+","+msg)

           // client.publish(this.publish.topic, this.publish.qos,this.msg);
            //第二个参数是发送的数据
         /*   client.publish(order, msg, error => {
                console.log(error);
                console.log(error || '消息发布成功');
                //this.showToast('消息发布成功', 1000, 'success')
            });*/

            client.publish(order, msg, error => {
                if (error) {
                    console.log('Publish error', error)
                }
            })
        },

        chars4() {
            let category_option2 = {

                tooltip: {
                    trigger: 'item'
                },

                series: [
                    {
                        name: '项目耗能',
                        type: 'pie',
                        radius: '70%',
                        data: [
                            {value: 0, name: '总耗能'},
                            {value: 0, name: '当月耗能'},
                        ],
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgb(86,239,247)'
                            }
                        },
                        itemStyle: {
                            normal: {
                                color: function (colors) {
                                    var colorList = [
                                        'rgba(10,203,188,0.48)',
                                        '#5470c6',
                                        '#91cd77',
                                        '#ef6567',
                                        '#f9c956',
                                        '#75bedc'
                                    ];
                                    return colorList[colors.dataIndex];
                                }
                            },
                        },
                        label: {            //饼图图形上的文本标签
                            normal: {
                                show: true,
                                position: 'outer', //标签的位置
                                textStyle: {
                                    fontWeight: 300,
                                    fontSize: 14,    //文字的字体大小
                                    color: "#fff"
                                },
                                formatter: '{b}:{c}'
                            }
                        },

                    }
                ]
            };


            category_option2.series[0].data[0].value = 122
            category_option2.series[0].data[1].value = 666

            var chartDom = document.getElementById('echarts_4');
            var myChart = echarts.init(chartDom);
            // 数据准备完毕之后再set
            myChart.setOption(category_option2);

        },
        chars6() {
            let option = {
                tooltip: {
                    trigger: 'item'
                },

                series: [
                    {
                        name: '设备概况',
                        type: 'pie',
                        radius: ['40%', '70%'],
                        avoidLabelOverlap: false,

                        itemStyle: {
                            borderRadius: 10,
                            borderColor: '#fff',
                            borderWidth: 2,
                            normal: {
                                color: function (colors) {
                                    var colorList = [
                                        'rgb(162,244,66)',
                                        'rgb(149,149,150)',
                                        '#e3131a',
                                        '#ef6567',
                                        '#9c1657',
                                        '#75bedc'
                                    ];
                                    return colorList[colors.dataIndex];
                                }
                            },
                        },
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgb(86,239,247)'

                            }
                        },
                        label: {            //饼图图形上的文本标签
                            normal: {
                                show: true,
                                position: 'outer', //标签的位置
                                textStyle: {
                                    fontWeight: 300,
                                    fontSize: 14,    //文字的字体大小
                                    color: "#fff"
                                },
                                formatter: '{b}:{c}'
                            }
                        },
                        data: [
                            {value: 0, name: '开灯数'},
                            {value: 0, name: '灭灯数'},

                        ]
                    }
                ]
            };


            option.series[0].data[0].value = 50
            option.series[0].data[1].value = 22
            var chartDom = document.getElementById('echarts_6');
            var myChart = echarts.init(chartDom);
            // 数据准备完毕之后再set
            myChart.setOption(option);
        },
        getdate(str) {

            var now = new Date(str),
                y = now.getFullYear(),
                m = now.getMonth() + 1,
                d = now.getDate();
            return y + "-" + (m < 10 ? "0" + m : m) + "-" + (d < 10 ? "0" + d : d) + " " + now.toTimeString().substr(0, 8);
        },
        showLocale(objD) {
            var str, colorhead, colorfoot;
            var yy = objD.getYear();
            if (yy < 1900) yy = yy + 1900;
            var MM = objD.getMonth() + 1;
            if (MM < 10) MM = '0' + MM;
            var dd = objD.getDate();
            if (dd < 10) dd = '0' + dd;
            var hh = objD.getHours();
            if (hh < 10) hh = '0' + hh;
            var mm = objD.getMinutes();
            if (mm < 10) mm = '0' + mm;
            var ss = objD.getSeconds();
            if (ss < 10) ss = '0' + ss;
            var ww = objD.getDay();
            if (ww == 0) colorhead = "";
            if (ww > 0 && ww < 6) colorhead = "";
            if (ww == 6) colorhead = "";
            if (ww == 0) ww = "星期日";
            if (ww == 1) ww = "星期一";
            if (ww == 2) ww = "星期二";
            if (ww == 3) ww = "星期三";
            if (ww == 4) ww = "星期四";
            if (ww == 5) ww = "星期五";
            if (ww == 6) ww = "星期六";
            colorfoot = ""
            str = colorhead + yy + "-" + MM + "-" + dd + " " + hh + ":" + mm + ":" + ss + "  " + ww + colorfoot;
            return (str);
        }
    }

}
</script>

<style scoped>
@import "../style/css/style_013.css";
/*@import "../style/css/amap.css";*/
/*@import "@/style/css/map.css";*/
/*@import "../style/amap.css";*/

.el-row {
    margin-bottom: 20px;

&
:last-child {
    margin-bottom: 0;
}

}
.el-col {
    border-radius: 4px;
}

.bg-purple-dark {
    background: #99a9bf;
}

.bg-purple {
    background: rgba(32, 99, 172, 0.91);
}

.bg-purple-light {
    background: #e5e9f2;
}

.grid-content {
    border-radius: 4px;
    min-height: 40px;
}

.row-bg {
    padding: 10px 0;
    background-color: #f9fafc;
}


.el-table,
.el-table__expanded-cell {
    background-color: transparent !important;
}

/* 表格内背景颜色 */

.el-table th,
.el-table tr,
.el-table td {
    background-color: transparent !important;
    border: 0;
}

/*最外层透明*/
/deep/ .el-table, /deep/ .el-table__expanded-cell {
    background-color: transparent;
}

/* 表格内背景颜色 */
/deep/ .el-table th,
/deep/ .el-table tr,
/deep/ .el-table td {
    background-color: transparent;
}

/* # background-color为悬停行得背景颜色 ,color为悬停行得字体颜色，其他样式自行添加 */
/deep/ .el-table tbody tr:hover > td {
    background-color: transparent !important;;
    color: #42b983;
    cursor: pointer;
}

::v-deep .el-table__body tr.current-row>td {
    color: #fff;
    background: #409EFF!important;
}







.input-card {
    color: white;
    z-index: 8;
    display: flex;
    flex-direction: column;
    min-width: 0;
    word-wrap: break-word;
    bottom: 10px;
    right: 10px;
    position: absolute;
    border: 1px solid #1d3152;
    box-shadow: 0 2px 6px 0 rgba(114, 124, 245, .5);
    border-radius: 0.4rem;
    padding: 0.5rem

}
.input-text {
    line-height: 2rem;
    margin-right: 2rem;
}
/*.input-card {
    display: flex;
    flex-direction: column;
    min-width: 0;
    word-wrap: break-word;
    background-color: #fff;
    background-clip: border-box;
    border-radius: .25rem;
    width: 22rem;
    border-width: 0;
    border-radius: 0.4rem;
    box-shadow: 0 2px 6px 0 rgba(114, 124, 245, .5);
    position: fixed;
    bottom: 1rem;
    right: 1rem;
    -ms-flex: 1 1 auto;
    flex: 1 1 auto;
    padding: 0.75rem 1.25rem;
}

.input-text {
    line-height: 2rem;
    margin-right: 2rem;
}*/

.my-label {
    background: #E1F3D8;
}

.my-content {
    background: #FDE2E2;
}



</style>
